import {inject, Injectable} from '@angular/core';
import {BaseModelService} from '../base-model.service';
import {UserSessionModelService} from '../Users/user-session-model.service';

@Injectable({
  providedIn: 'root',
})
export abstract class UserPreferencesModelService<T> extends BaseModelService {

  protected readonly userSession = inject(UserSessionModelService);


  /**
   * Convierte un elemento del formato antiguo al formato actual
   *
   */
  protected abstract mapLegacyItem(item: any): T;


  /**
   * Obtiene la configuración del usuario en sesión
   *
   */
  public async getForUser(): Promise<T[] | null> {
    const userId: string | null = this.userSession.currentUserId;

    if (!userId) {
      return [];
    }

    const stored: Record<string, T[]> | null = await this.list();

    if (Array.isArray(stored)) {
      return this.migrateLegacy(stored, userId);
    }

    return stored?.[userId] ?? null;
  }


  /**
   * Guarda la configuración del usuario en sesión
   *
   */
  public async saveForUser(items: T[]): Promise<T[]> {
    const userId: string | null = this.userSession.currentUserId;

      if (!userId) {
        return items;
      }

      const stored: Record<string, T[]> | null = await this.list();
      const users: Record<string, T[]> = !stored || Array.isArray(stored) ? {} : stored;

      await this.save({...users, [userId]: items});
      return items;
  }


  /**
   * Asigna la configuración guardada en el formato antiguo al usuario en sesión
   *
   */
  private async migrateLegacy(legacyItems: any[], userId: string): Promise<T[]> {
    const items: T[] = legacyItems.map((item) => this.mapLegacyItem(item));

    await this.save({[userId]: items});
    return items;
  }

}
